import axios from "axios";
import { baseUrl } from '../../config/clientsConfig'

const LocationService ={
    fetchLocation: ()=>{
        return axios.get(`${baseUrl}/locations`);
    },
    createLocation: (name)=>{
return axios.post(`${baseUrl}/location`,{name});
    },
    updateLocation: (id, name)=>{
        return axios.put(`${baseUrl}/location`,{id,name})
    }
}

export default LocationService;